import { Component, inject, OnInit, OnDestroy, signal } from '@angular/core';
import { DriverInformationDetailsComponent } from './components/driver-information-details/driver-information-details.component';
import { DriverInformationListComponent } from './components/driver-information-list/driver-information-list.component';
import { DriverSearchFilterComponent } from '../driver-search-filter/driver-search-filter.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AddDriversDialogComponent } from './components/add-drivers-dialog/add-drivers-dialog.component';
import { CommonModule } from '@angular/common';
import { DriverInformationListService } from './services/driver-information-list.service';
import { Subscription } from 'rxjs';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-driver-information',
  standalone: true,
  imports: [DriverInformationDetailsComponent, DriverInformationListComponent, DriverSearchFilterComponent, CommonModule, TranslocoDirective],
  templateUrl: './driver-information.component.html',
  styleUrl: './driver-information.component.scss',
})
export class DriverInformationComponent implements OnInit, OnDestroy {

  public listLoaded: boolean = false;
  public detailsLoaded: boolean = false;
  public isDriverFound: boolean = true;
  public isSearching: boolean = false;
  public showAddDriver: boolean = false;
  public hasDrivers = signal(null);

  private driverSubscription: Subscription;
  private searchSubscription: Subscription;
  private modalService = inject(NgbModal);
  private driverService = inject(DriverInformationListService);

  ngOnInit(): void {
    this.subscribeToFilters();
    this.subscribeToSearch();
  }

  openAddDriverModal() {
    const modalOptions: NgbModalOptions = {
      centered: true,
      backdrop: 'static'
    };

    this.modalService.open(AddDriversDialogComponent, modalOptions);
  }

  private subscribeToFilters(): void {
    this.driverSubscription = this.driverService.drivers$.subscribe(drivers => {
      this.isDriverFound = Array.isArray(drivers) && drivers.length > 0;
      this.listLoaded = true;
      this.detailsLoaded = true;
    });
  }

  private subscribeToSearch(): void {
    this.searchSubscription = this.driverService.searchTerm$.subscribe(searchTerm => {
      this.isSearching = searchTerm.trim().length > 0;
      this.listLoaded = false;
      this.detailsLoaded = false;
    });
  }

  ngOnDestroy(): void {
    if (this.driverSubscription) {
      this.driverSubscription.unsubscribe();
    }

    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
  }
}